import type { BaseOperationDurationParams } from 'root/services/biReporterService';

interface MonitorOptions<T, R> {
  /** Optional name for the monitored operation (useful for logging) */
  name?: string;
  /** The function to monitor */
  callback: () => Promise<T> | T;
  monitorBiEvent: (params: R) => void;
  params?: R;
  isAPI?: boolean;
}
/**
 * A wrapper function that monitors the execution duration of a callback
 * @param options - Configuration options
 * @returns A tuple containing the result of the callback and the duration in milliseconds
 */
export const withBIDuration = async <T, R extends BaseOperationDurationParams>({
  callback,
  name,
  monitorBiEvent,
  params,
  isAPI = false,
}: MonitorOptions<T, R>): Promise<T> => {
  const start = performance.now();

  try {
    const result = await callback();
    sentBIEvent();

    return result;
  } catch (error) {
    if (!params) {
      params = {} as R;
    }
    if (!params?.extraFields) {
      params.extraFields = {};
    }
    // @ts-expect-error
    isAPI && (params.extraFields.apiErrorMsg = error.message);

    sentBIEvent();
    throw error;
  }

  function sentBIEvent() {
    if (params) {
      const duration = performance.now() - start;
      params.duration = Math.round(duration);
      params.eventName = isAPI ? `[API] ${name}` : name;
      monitorBiEvent?.(params);
      return duration;
    }
  }
};
